import { useState } from 'react'
import { getKohorte, setKohorte } from '@/core/lib/kohortePrefs'

export function useKohortePref(): [string | null, (beginn: string | null) => void] {
  const [kohorte, setState] = useState<string | null>(getKohorte)
  const set = (beginn: string | null) => {
    setState(beginn)
    setKohorte(beginn)
  }
  return [kohorte, set]
}
